import {useEffect, useState} from 'react';

import {useUnmountCancelToken} from '../../../../../srcCommon/helpers/hookHelpers';
import {useAppSelector} from '../../../../helpers/reduxHelpers';
import {InboxModel} from '../../../../models/api/inboxModel';
import {getCompany} from '../../../../store/data/company/companySelectors';
import {useRuleEditorServiceContext} from './useRuleEditorServiceContext';

// TODO: Remove this & compute rule impact in the BE.
export function useAllInboxes() {
  const [inboxes, setInboxes] = useState<ReadonlyArray<InboxModel>>([]);
  const {url: companyUrl} = useAppSelector(getCompany);
  const cancelToken = useUnmountCancelToken();
  const {inboxService} = useRuleEditorServiceContext();

  useEffect(() => {
    inboxService.fetchAll({companyUrl, cancelToken}).then(setInboxes);
  }, [companyUrl]);

  return inboxes;
}
